import {useState} from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiCheck,FiZap}=FiIcons;

export function ModelTierSelector({tiers,value,onChange}) {
  return (
    <div className="tier-selector">
      {tiers.map((tier)=> (
        <button
          type="button"
          key={tier.id}
          className={value===tier.id ? 'tier-card selected' : 'tier-card'}
          onClick={()=> onChange?.(tier.id)}
        >
          <SafeIcon icon={FiZap} />
          <div>
            <b>{tier.name}</b>
            <small>{tier.description}</small>
            <span>{tier.speed} · {tier.cost}</span>
          </div>
          {value===tier.id && <SafeIcon icon={FiCheck} className="tier-check" />}
        </button>
      ))}
    </div>
  );
}

export function ProviderSelector({providers=[],value,onChange}) {
  return (
    <div className="provider-selector">
      {providers.map((provider)=> (
        <button
          type="button"
          key={provider.id}
          className={value===provider.id ? 'tier-card selected' : 'tier-card'}
          onClick={()=> onChange?.(provider.id)}
        >
          <SafeIcon icon={FiZap} />
          <div>
            <b>{provider.label}</b>
            <small>{provider.provider}</small>
            <span>{provider.model}</span>
          </div>
          {value===provider.id && <SafeIcon icon={FiCheck} className="tier-check" />}
        </button>
      ))}
    </div>
  );
}

export function MarketplaceCard({item,installed,onInstall}) {
  return (
    <article className="market-card">
      <span className="market-icon" style={{background: item.color}}>{item.roster[0]}</span>
      <span className="eyebrow">Single specialist</span>
      <h3>{item.name}</h3>
      <p>{item.description}</p>
      <button className="button primary" disabled={installed} onClick={onInstall}>
        {installed ? 'Installed' : 'Install bot'}
      </button>
    </article>
  );
}

export function TeamBundleCard({item,installed,onInstall}) {
  const [showRoster, setShowRoster] = useState(true);
  const rosterDetails = item.rosterDetails || item.roster?.map((name) => ({name, role: 'Specialist', description: 'Team member'}));

  return (
    <article className="market-card featured" style={{gridColumn: '1 / -1'}}>
      <div className="inline spread" style={{width: '100%'}}>
        <div>
          <span className="eyebrow">Complete team bundle</span>
          <h3>{item.name}</h3>
        </div>
        <span className="count" style={{background: 'rgba(255,255,255,0.15)', color: 'white'}}>
          {rosterDetails.length} bots
        </span>
      </div>

      <p>{item.description}</p>

      {/* Full Roster Preview (Roles + Descriptions) */}
      <div className="market-roster-preview" style={{width: '100%', margin: '16px 0', display: 'flex', flexDirection: 'column', gap: '10px'}}>
        <span className="eyebrow" style={{color: '#abb3c0', fontSize: '11px'}}>Staffed Team Roster</span>
        <div className="roster-preview-grid" style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '12px'}}>
          {rosterDetails.map((bot) => (
            <div
              key={bot.name}
              className="roster-preview-card"
              style={{
                padding: '12px 14px',
                borderRadius: 'var(--radius-sm)',
                background: 'rgba(255, 255, 255, 0.08)',
                border: '1px solid rgba(255, 255, 255, 0.12)'
              }}
            >
              <div className="inline" style={{gap: '8px', marginBottom: '6px'}}>
                <span className="avatar dark small" style={{background: bot.isLead ? 'var(--color-gold)' : '#374151', color: bot.isLead ? 'var(--color-ink)' : 'white'}}>
                  {bot.name[0]}
                </span>
                <b>{bot.name}</b>
                <span className="status" style={{fontSize: '10px', padding: '1px 6px', background: bot.isLead ? '#fef3c7' : 'rgba(255,255,255,0.15)', color: bot.isLead ? '#92400e' : '#e5e7eb'}}>
                  {bot.isLead ? 'Team Lead' : (bot.role || 'Specialist')}
                </span>
              </div>
              <p style={{fontSize: 'var(--type-xs)', color: '#9ca3af', margin: 0, lineHeight: 1.4}}>
                {bot.description || `Specialist for ${item.name}`}
              </p>
            </div>
          ))}
        </div>
      </div>

      <button className="button primary" disabled={installed} onClick={onInstall}>
        {installed ? 'Team installed' : `Install whole team (${rosterDetails.length} bots)`}
      </button>
    </article>
  );
}